// test1532
(1532 && 0);
